import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../actions/actionCreators.js";


import UsersPage from "../components/UsersPage";


function mapStateToProps(state){
	//console.log("Connecting state", state.series);
	return {
		lang: state.data.lang,
		auth: state.data.auth,
		firm: state.data.userInfo.firm,
		rank: state.data.userInfo.rank,
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(actionCreators, dispatch);
}


const UsersContainer = connect(mapStateToProps, mapDispatchToProps)(UsersPage);

export default UsersContainer;


// WEBPACK FOOTER //
// ./src/containers/UsersContainer.js